var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5H4C3.44771 20.5 3.00399 20.0526 3.05893 19.5031C3.1654 18.4381 3.46425 16.7794 4.30305 15.8574C5.61647 14.4257 7.30858 14.2905 8.18815 13.2098C8.50026 12.8263 8.26657 12.2997 7.87374 11.9995C7.40499 11.6412 7.00556 11.2015 6.69714 10.7004C6.23974 9.95717 5.9998 9.10705 6.00313 8.24143C5.97029 7.01692 6.43964 5.82981 7.30811 4.94081C8.17658 4.05182 9.37316 3.53361 10.6351 3.5C11.8943 3.53616 13.0873 4.05581 13.952 4.94482C14.8166 5.83384 15.2823 7.01951 15.2467 8.24143C15.2516 9.10628 15.0147 9.95623 14.5611 10.7007C14.2623 11.1913 13.8768 11.624 13.4245 11.9801C13.0227 12.2965 12.8026 12.8449 13.1261 13.241C13.206 13.3388 13.2923 13.4319 13.3847 13.5196C13.6974 13.8161 14.0719 14.044 14.4832 14.188L16 14.9091",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 18.5C20.5 18.1048 20.3829 17.7185 20.1635 17.3898C19.9442 17.0611 19.6323 16.8047 19.2674 16.6531C18.9025 16.5015 18.5008 16.4613 18.1131 16.5378C17.7253 16.6142 17.369 16.8038 17.0889 17.0827C16.8089 17.3615 16.6177 17.717 16.5395 18.1044C16.4613 18.4918 16.4997 18.8936 16.6497 19.2592C16.7997 19.6248 17.0547 19.9378 17.3824 20.1586C17.7102 20.3794 18.096 20.4982 18.4912 20.5C18.7545 20.5011 19.0156 20.4503 19.2592 20.3503C19.5029 20.2503 19.7244 20.1032 19.9111 19.9173C20.0977 19.7315 20.2459 19.5106 20.3469 19.2674C20.448 19.0242 20.5 18.7634 20.5 18.5V18.5Z",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17L18.5192 10H21",
    stroke: "#181818",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.5H21",
    stroke: "#181818",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon-admin.2d6f510968f2f3f240f5080ade557190.svg";
export { ForwardRef as ReactComponent };